
      import Vue from 'vue';
      export default {
        scrollToTop: true,
        head() {
          return {
            title: this.title,
            meta: [{
                hid: 'og:title',
                property: 'og:title',
                content: this.title 
              },
              {
                hid: 'twitter:title',
                property: 'twitter:title',
                content: this.title 
              },
              {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Arti Sai Baba, Saukhyadaataara Jeeva" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Arti Sai Baba, Saukhyadaataara Jeeva" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Aarti Sai Baba, Shirdi Sai Baba, Sai Aarti, Shirdi Sai Baba Aarti lyrics, Shirdi Sai Baba Aarti lyrics marathi, Shirdi Sai Baba Aarti lyrics english'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Aarti Sai Baba, Shirdi Sai Baba, Sai Aarti, Sai Baba worship, Sai Baba Bhajan, Shirdi Sai Baba Aarti lyrics, Shirdi Sai Baba Bhajan lyrics, devotional aarti, Sai Baba ki Aarti, Sai Baba Bhajan lyrics in Hindi, sai baba aarti lyrics, साई बाबा आरती, sai baba aarti lyrics in english, sai baba aarti lyrics in marathi, sai baba aarti lyrics'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/saibaba.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/saibaba.webp'
          },
            ],
          }
        },
      
          components: {
       },
       data() {
         return {
           title:'Arti Sai Baba, Saukhyadaataara Jeeva | Aarti Shri Saibaba - आरती साईबाबा सौख्यदातारा जीवा (साईबाबाची आरती)',
           langauageMarathi: true
         }
       },
       layout: 'detailsPage-withoutFooter',
   
       jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/saibaba"
        },
        "headline": "Arti Sai Baba, Saukhyadaataara Jeeva - आरती साईबाबा सौख्यदातारा जीवा (साईबाबाची आरती)",
        "name" : "Arti Sai Baba, Saukhyadaataara Jeeva - Aarti Shri Saibaba",
        "description": "Explore the full lyrics of Aarti 'Arti Sai Baba, Saukhyadaataara Jeeva' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/saibaba.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
   
       computed: {
   
       },
       methods:{
       changeLanguage:function () {
         this.langauageMarathi = !this.langauageMarathi
       }
     }
   
     }
   